import React from "react";
import { RiArrowDownSLine } from "react-icons/ri";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import navbarDataTH from "../../../languages/th/navbar.json";
import navbarDataEN from "../../../languages/en/navbar.json";

import { useLanguage } from "../../../context/LanguageContext";

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
    // Update the URL with the section id
    window.history.pushState(null, null, `#${sectionId}`);
  }
};

const NavbarD = ({ theme = "white" }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { selectedLanguage, setSelectedLanguage } = useLanguage(); // Use the context
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const navbarData = selectedLanguage === "th" ? navbarDataTH : navbarDataEN;

  const toggleDropdownLang = () => {
    setIsDropdownOpen((prevState) => !prevState);
    setIsDropdownVisible(false);
  };

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    setIsDropdownOpen(false);
  };

  // Get the current pathname using window.location.pathname
  const currentPath = window.location.pathname;

  const navigate = useNavigate();

  // Function to check if the link matches the current path
  const isCurrentPath = (linkPath) => {
    return currentPath === linkPath;
  };

  // State to control the dropdown visibility

  // Function to toggle the dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = [, "about", "packages"];
      for (const sectionId of sections) {
        const section = document.getElementById(sectionId);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top >= 0 && rect.top <= window.innerHeight) {
            window.history.replaceState(null, null, `#${sectionId}`);
            break;
          }
        }
      }
      if (window.scrollY === 0) {
        window.history.replaceState(null, null, "/");
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("load", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`p-4 flex justify-around items-center w-full px-6 
       ${theme === "white" ? "text-white" : "text-black"}`}
    >
      <div className="flex items-center">
        {/* Logo */}
        <img
          src={
            theme === "white"
              ? process.env.PUBLIC_URL +
                "/Logo/white_logo-navbar_desktop 241x49.png"
              : process.env.PUBLIC_URL +
                "/Logo/black_logo-navbar_desktop 241x49.png"
          }
          alt="Logo"
          className="h-8 w-auto mr-4"
        />

        {/* Navigation Links */}
        <ul className="flex items-center gap-12">
          <li className={` font-feature-settings-off font-prompt font-medium`}>
            <a
              className={` 
               cursor-pointer ${isCurrentPath("/") ? "text-primary-900" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                navigate("/");
              }}
            >
              {navbarData.home}
            </a>
          </li>
          <li className={` font-feature-settings-off font-prompt font-medium`}>
            <a
              className={`  cursor-pointer
                
               ${isCurrentPath("/about") ? "text-primary-900" : ""}`}
              onClick={() => scrollToSection("about")}
            >
              {navbarData.about}
            </a>
          </li>
          <li
            className={`font-feature-settings-off font-prompt font-medium relative group `}
          >
            <a
              href="#"
              onClick={toggleDropdown}
              className={`flex items-center ${
                isCurrentPath("/how-to-use") ? "text-primary-900" : ""
              }`}
            >
              {navbarData.howto}
              <RiArrowDownSLine className="inline-block ml-1" />
            </a>
            {/* Dropdown */}
            {isDropdownVisible && (
              <ul
                className="absolute bg-white text-gray-800 py-2 mt-2 rounded-md
                    w-44
                "
                onMouseLeave={() => setIsDropdownVisible(false)}
              >
                <li>
                  <a
                    href={
                      process.env.PUBLIC_URL + "/about%20us/Instructions.pdf"
                    }
                    target="_blank" // Open link in a new tab
                    rel="noopener noreferrer" // Recommended for security reasons
                    className="block px-4 py-2 hover:bg-gray-200"
                  >
                    {navbarData.mInstruction}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/@chatnshops"
                    target="_blank"
                    className="block px-4 py-2 hover:bg-gray-200"
                  >
                    {navbarData.vInstruction}
                  </a>
                </li>
              </ul>
            )}
          </li>
          <li
            className={` flex items-center font-feature-settings-off font-prompt font-medium `}
          >
            <a
              className={`  cursor-pointer
              ${isCurrentPath("/packages") ? "text-primary-900" : ""}`}
              onClick={() => scrollToSection("packages")}
            >
              {navbarData.packages}
            </a>
          </li>
        </ul>
      </div>

      {/* Language and Subscribe */}

      <div className="flex relative ml-2">
        <div
          className="flex items-center  font-feature-settings-off  
          font-prompt font-medium cursor-pointer"
          onClick={toggleDropdownLang}
        >
          <img
            src={
              selectedLanguage === "th"
                ? process.env.PUBLIC_URL + "/mian/languages/Thailand.svg"
                : process.env.PUBLIC_URL + "/mian/languages/English.svg"
            }
            alt="Language"
            className="w-8"
          />
        </div>
        {isDropdownOpen && (
          <div
            className="absolute top-10 right-24 bg-white shadow-md rounded-md p-2 w-40"
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <div
              className={`cursor-pointer relative text-gray-700 ${
                selectedLanguage === "th" ? "text-primary-900 font-light" : ""
              }`}
              onClick={() => handleLanguageChange("th")}
            >
              <img
                src={process.env.PUBLIC_URL + "/mian/languages/Thailand.svg"}
                alt="Thai"
                className="w-6 h-6 inline mr-2"
              />
              ไทย
              {selectedLanguage === "th" && (
                <span className="absolute right-4 top-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    className=""
                  >
                    <path
                      d="M7.16172 13.5002L2.88672 9.22519L3.95547 8.15645L7.16172 11.3627L14.043 4.48145L15.1117 5.5502L7.16172 13.5002Z"
                      fill="#1DAB59"
                      className="mt-12"
                    />
                  </svg>
                </span>
              )}
            </div>
            <div
              className={`cursor-pointer text-gray-700
               ${
                 selectedLanguage === "en" ? "text-primary-900 font-light" : ""
               }`}
              onClick={() => handleLanguageChange("en")}
            >
              <img
                src={process.env.PUBLIC_URL + "/mian/languages/English.svg"}
                alt="English"
                className="w-6 h-6 inline mr-2"
              />
              English
              {selectedLanguage === "en" && (
                <span className="absolute right-4 bottom-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    className=""
                  >
                    <path
                      d="M7.16172 13.5002L2.88672 9.22519L3.95547 8.15645L7.16172 11.3627L14.043 4.48145L15.1117 5.5502L7.16172 13.5002Z"
                      fill="#1DAB59"
                      className="mt-12"
                    />
                  </svg>
                </span>
              )}
            </div>
          </div>
        )}

        <div>
          <button
            className="mx-4 text-center"
            onClick={(e) => {
              e.preventDefault();
              navigate("/login");
            }}
          >
            {navbarData.login}
          </button>
          <button
            className={`bg-primary-900 px-4 py-2 rounded-3xl font-feature-settings-off font-prompt font-medium
                text-white`}
            onClick={(e) => {
              e.preventDefault();
              navigate("/register");
            }}
          >
            {navbarData.register}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavbarD;
